import { FC } from "react";
import TabGroups from "./Variants/TabGroups/TabGroups";
import Dashboard from "./Variants/Dashboard";
import { useSettingsContext } from "../Settings/hooks/useSettingsContext";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Home: FC = () => {
  const Settings = useSettingsContext();
  const { t } = useTranslation();

  switch(Settings?.home?.type) {
    case 'tabGroups':
      return <TabGroups homeSettings={Settings.home}/>
    case 'dashboard':
      return <Dashboard />
    default:
      return <Navigate to={t("common:url.invoices")}/>
  }
}

export default Home;
